export interface ClientVisitInterface {
  id: string;
  notes?: string | null;
  riskLevel?: number;
  safetyPlanAsOf?: string | null;
  status: number;
  visitDate: string;
  createdAt: string;
  updatedAt: string;
  clientId: string;
  programId: string;
  program?: { id: string; name: string };
}

export class ClientVisit implements ClientVisitInterface {
  id: string;
  notes?: string | null;
  riskLevel?: number;
  safetyPlanAsOf?: string | null;
  status: number;
  visitDate: string;
  createdAt: string;
  updatedAt: string;
  clientId: string;
  programId: string;
  program?: { id: string; name: string };

  constructor(data: Partial<ClientVisitInterface>) {
    this.id = data.id!;
    this.notes = data.notes ?? null;
    this.riskLevel = data.riskLevel ?? 0;
    this.safetyPlanAsOf = data.safetyPlanAsOf ?? null;
    this.status = data.status ?? 0;
    this.visitDate = data.visitDate!;
    this.createdAt = data.createdAt!;
    this.updatedAt = data.updatedAt!;
    this.clientId = data.clientId!;
    this.programId = data.programId!;
    this.program = data.program;
  }

  toJson(): ClientVisitInterface {
    return {
      id: this.id,
      notes: this.notes,
      riskLevel: this.riskLevel,
      safetyPlanAsOf: this.safetyPlanAsOf,
      status: this.status,
      visitDate: this.visitDate,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      clientId: this.clientId,
      programId: this.programId,
      program: this.program,
    };
  }
}

